module.exports = __webpack_public_path__ + "img/Frame6592.3e2ab60d.svg";